import { HelmetDatoCms } from 'gatsby-source-datocms'
import { get, set } from 'lodash'
import React from 'react'


const SEO = ({ tags, favicon, siteURL, pagePath, schema }) => {

	// workaround for null tags
	set(tags, "tags", get(tags, "tags", []).filter(t => t !== null))

	return (
		<HelmetDatoCms seo={tags} favicon={favicon}>
			<html lang="en-gb" />

			<script>{`
				if (typeof window !== 'undefined' && typeof window.Proxy === 'undefined') {
					window.location.replace('/unsupported.html')
				}
			`}</script>

			{siteURL && pagePath && <link rel="canonical" href={`${siteURL}${pagePath}`} />}
			{siteURL && pagePath && <meta property="og:url" content={`${siteURL}${pagePath}`} />}
			{schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
		</HelmetDatoCms>
	)
}

export default SEO;